import { Component, Prop, Vue } from "vue-property-decorator";

import gql from "graphql-tag";

import LIST_DIRECTORY from "@/apollo/directory/ListDirectory.gql";
import CREATE_FAVORITE from "@/apollo/directory/CreateFavorite.gql";
import DELETE_FAVORITE from "@/apollo/directory/DeleteFavorite.gql";
import Message from '@/data/notificationsMessages';
import { NOTIFICATION } from '@/entities/Events';

import {
  Contractor,
  Mutation_RootDelete_User_FavoriteArgs,
  Mutation_RootInsert_User_FavoriteArgs,
  Mutation_RootInsert_User_Favorite_OneArgs,
  User,
} from "@/generated/graphql";

@Component
export default class DirectoryMixins extends Vue {
  @Prop({  type: Object, default: () => ({}) }) data!: any;
  @Prop({ type: Object, required: true }) readonly currentUser!: User;

  teamDialog: boolean = false;
  projectDialog: boolean = false;
  selectedContractor: Contractor | null = null;

  get directoryFilter(): any {
    return;
  }

  get currentUserId(): string {
    return this.currentUser.id;
  }

  addProject(contractor: Contractor): void {
    this.projectDialog = true;
    this.selectedContractor = contractor;
  }

  addTeam(contractor: Contractor): void {
    this.teamDialog = true;
    this.selectedContractor = contractor;
  }

  async toggleFavourite(user: User): Promise<void> {
    try {
      const object = {
        favorited_id: user.id,
        favorited_by_id: this.currentUserId,
      };
      const where = {
        favorited_id: { _eq: user.id },
        favorited_by_id: { _eq: this.currentUserId },
      };
      const response = user.favorited_by_users[0]
        ? await this._deleteFavorite({ where })
        : await this._createFavorite({ object });

      if (response.data.insert_user_favorite_one) {
        user.favorited_by_users.push(response.data.insert_user_favorite_one);
      }

      if (response.data.delete_user_favorite) {
        user.favorited_by_users = [];
      }

      const cache = this.$apollo.provider.defaultClient.readQuery({
        query: LIST_DIRECTORY,
        variables: this.directoryFilter,
      });

      this.$apollo.provider.defaultClient.writeQuery({
        query: LIST_DIRECTORY,
        variables: this.directoryFilter,
        data: {
          ...cache,
          contractor: cache.contractor.map((item: any) =>
            item.id === user.id ? user : item
          ),
        },
      });
      this.$eventBus.emit(NOTIFICATION, Message.successMessage("Updated"));
    } catch (e) {
      this.$eventBus.emit(NOTIFICATION, Message.errorMessage(e.message));
    }
  }

  async _deleteFavorite(where: Mutation_RootDelete_User_FavoriteArgs) {
    return await this.$apollo.mutate({
      mutation: DELETE_FAVORITE,
      variables: where,
    });
  }

  async _createFavorite(object: Mutation_RootInsert_User_Favorite_OneArgs) {
    return await this.$apollo.mutate({
      mutation: CREATE_FAVORITE,
      variables: object,
    });
  }

  async updateTeamContractor(input: any) {
    try {
      await this._updateTeamContractor(input);
    } catch (e) {
      throw e;
    }
  }

  async _updateTeamContractor(input: any) {
    const UPDATE_TEAM_CONTRACTOR = gql`
      mutation CreateTeamContractor(
        $objects: [team_contractor_insert_input!]!
        $where: team_contractor_bool_exp!
      ) {
        insert_team_contractor(objects: $objects) {
          returning {
            id
          }
        }
        delete_team_contractor(where: $where) {
          returning {
            id
          }
        }
      }
    `;

    return await this.$apollo.mutate({
      mutation: UPDATE_TEAM_CONTRACTOR,
      variables: input,
    });
  }

  async updateContractorProject(input: any) {
    try {
      await this._updateContractorProject(input);
    } catch (e) {
      throw e;
    }
  }

  async _updateContractorProject(input: any) {
    const UPDATE_CONTRACTOR_PROJECT = gql`
      mutation CreateContractorProject(
        $objects: [contractor_project_insert_input!]!
        $where: contractor_project_bool_exp!
      ) {
        insert_contractor_project(objects: $objects) {
          returning {
            id
          }
        }
        delete_contractor_project(where: $where) {
          returning {
            id
          }
        }
      }
    `;

    return await this.$apollo.mutate({
      mutation: UPDATE_CONTRACTOR_PROJECT,
      variables: input,
    });
  }
}
